const Required = () => {
  return <i className={`material-icons text-sm pr-1 text-red-500`}>star</i>;
};

export default Required;
